import React from 'react'
import { Alert, Box } from '@mui/material'
import FormularioDinamico from '@/components/formulario/FormularioDinamico'
import { SchemaFormulario } from '@/types/formularioAdmin'

/**
 * Prévia do formulário como o consultor vai ver (AN-6 §6).
 *
 * PONTO DE ENCAIXE (integração da Onda 4): o corpo é o renderizador oficial do consultor,
 * `components/formulario/FormularioDinamico.tsx` (DEV-L), sem respostas, sem pendências e
 * somente leitura — a mesma lógica de condição/asterisco/cartões de grupo que o consultor
 * usa, sem uma segunda implementação. Campos condicionais aparecem quando a condição é
 * satisfeita, como na tela real.
 */
const PreviaFormularioProduto: React.FC<{ schema: SchemaFormulario }> = ({ schema }) => {
  if (schema.itens.length === 0) {
    return <Alert severity="info">Este produto não solicita dados nesta etapa.</Alert>
  }
  return (
    <Box aria-label="Prévia do formulário">
      <FormularioDinamico schema={schema} respostas={[]} pendencias={[]} somenteLeitura onChange={() => {}} />
    </Box>
  )
}

export default PreviaFormularioProduto
